import { useQuery } from '@tanstack/vue-query';
import { type Ref } from 'vue';

import personApiService from '~/services/person-api/person-api';
import { PersonAPI } from '~/services/person-api/person-api.types';

export default function useDownloadOperationalAgreement(partnerId: number, enabled: boolean | Ref<boolean> = false) {
  return useQuery({
    enabled,
    queryFn: async (): Promise<PersonAPI.GetSignedOperatingAgreementResponse> => {
      const response = await personApiService.partner.getSignedOperatingAgreement(partnerId);
      return response;
    },
    queryKey: ['partner', partnerId, 'operating-agreement'],
    retry: 3,
  });
}
